import { TripItem } from 'tripPlanner/types/tripItem'

export const newDetailCardImplementedTypes = new Set<TripItem['type']>([
  'HOTEL',
  'ACCOMMODATION',
  'ACCOMMODATION_RENTAL',
  'AIRBNB',
  'ATTRACTION',
  'RESTAURANT_BAR',
  'EVENT',
  'THING_TO_DO',
  'EXPERIENCE',
  'FLIGHT',
])
